export const phrases = {
  heading_settings_sort: "Ordenação da lista de empregados",
  body_settings_sort: "Ordenar a lista de empregados por nome próprio ou apelido.",
  since_o_clock: "Desde {time} horas",
  old_data_warning_my_area: "Não foi possível carregar nenhuma informação nova. Certifique-se de que está ligado à Internet.",
  no_data_warning_my_area: "Certifique-se de que está ligado à Internet e tente novamente.",
  no_data_available_my_area: "Não é possível carregar dados",
  last_update_data: "Última atualização",
  something_went_wrong_absences: "Algo correu mal. Tente novamente numa data posterior.",
  something_went_wrong_with_the_pin_entry: "Algo correu mal com a introdução do PIN...",
  pin_must_be_four_digits: "O PIN deve ser composto por exatamente quatro dígitos.",
  pins_do_not_match: "Os PINs introduzidos não coincidem.",
  pin_is_not_numerical: "O PIN só pode ser composto por números.",
  /** Phrasen für Task.getTechnicalNameFinish
   * -> müssen vermutlich irgendwann nochmal bearbeitet werden
   * z.B. 'Projekt beenden' macht eventuell keinen Sinn, wenn man das Projekt nicht beendet,
   * sondern nur die Arbeitszeit, die man auf dieses Projekt stempelt ?
   */
  finish_work_time: "Carimbar",
  finish_break: "Fim da pausa",
  finish_loading_time: "Tempo de carregamento final",
  finish_driving_time: "Tempo de viagem final",
  finish_business_trip: "Fim do período de serviço",
  finish_project_as_task: "Concluir o projeto",
  finish_special_one: "Fim de special1",
  finish_special_two: "Fim de special2",
  you_clockout: "Tu te apagas",
  sentence_work_time: "Está a trabalhar neste momento. | Estás a trabalhar neste momento.",
  sentence_break: "Está a fazer uma pausa. | Está a fazer uma pausa.",
  sentence_loading_time: "Está a registar o tempo de carregamento. Hauruck! | Está a registar o tempo de carregamento. Hauruck!",
  sentence_business_trip: "Registado para uma viagem de negócios. Diverte-te!",
  sentence_driving_time: "Está a reservar o tempo de viagem. Aperte o cinto de segurança e vá-se embora! | Está a reservar o tempo de viagem. Aperte o cinto de segurança e vá!",
  sentence_special_one: "Está atualmente a reservar o Sonder1. | Está atualmente a reservar o especial 1.",
  sentence_special_two: "Está a reservar o Sonder2. | Está atualmente a reservar o Sonder2.",
  sentence_custom_time: "Está atualmente a reservar | Está atualmente a reservar",
  you_are_booked_in_activity: "Está a carimbar {activity}! | Está a carimbar {activity}!",
  substitute_warning: "Deve ser nomeado um adjunto para ausências iguais ou superiores a { days } dias.",
  substituted_by: "Representado por",
  name_clocked_in: "{name} carimbado",
  /************************************/
  //Signature stuff:

  signature: "Assinatura",
  please_sign: "Por favor, assine",
  signature_with_date: "Assinatura de {date}",
  signature_with_date_with_name: "Assinatura de {date} de {name}",
  signature_with_date_with_location: "Assinatura de {date} em {location}",
  signature_with_date_with_name_with_location: "Assinatura de {date} de {name} em {location}",
  signature_with_name: "Assinatura de {name}",
  signature_with_name_with_location: "Assinatura de {name} em {location}",
  signature_with_location: "Assinatura em {location}",
  /*************************************/

  accept_terms_and_conditions: "Ao submeter o formulário, o utilizador aceita o nosso {agb} e o nosso {datenschutzerklaerung}.",
  what_is_your_name: "Qual é o seu nome?",
  your_email: "O seu endereço eletrónico",
  what_is_your_company_name: "Qual é o nome da vossa empresa?",
  what_do_you_want_to_do_with_clockin: "Como gostaria de registar os tempos de trabalho no sistema clockin?",
  almost_finished: "Quase lá",
  test_clockin_for_amount_period: "Experimente o clockin {amountOfDaysTestPeriod} gratuitamente durante alguns dias!",
  code_needed_to_connect: "Utilizar o seu código",
  you_have_no_company_code: "Não tem um código? Entre em contacto com a pessoa de contacto da sua empresa.",
  connect_your_device: "Ligue o seu dispositivo!",
  please_type_in_device_id: "Introduza o ID do dispositivo que pode encontrar em dispositivos móveis no nosso sítio Web.",
  new_at_clockin: "Novo no mundo dos relógios?",
  pin_repeat: "Repetir PIN",
  configure_your_pin: "Definir o seu PIN de 4 dígitos",
  configure_your_pin_text: "O PIN é necessário para aceder à sua área pessoal no terminal tablet.",
  congratulations: "Parabéns!",
  start_now: "Começar agora",
  device_name_info: "Pode alterar o nome do dispositivo do seu telemóvel para que possa controlar vários dispositivos. Exemplo: \"Smartphone MaxMustermann\". O nome também pode ser alterado numa data posterior.",
  select_project: "Selecionar projeto",
  select_time: "Hora selecionada",
  create_new_account: "Criar uma nova conta",
  join_my_company: "Junta-te à minha empresa",
  join_clockin_with_qr: "Aderir com o código QR",
  change_project: "Projeto de mudança",
  my_messages: "As minhas mensagens",
  my_documents: "Os meus documentos",
  my_data_and_passwords: "Os meus dados e palavras-passe",
  my_account_data: "Os meus dados",
  change_my_password: "Alterar a palavra-passe",
  forgot_password: "Não sei a minha palavra-passe.",
  open_camera: "Câmara aberta",
  scan_now: "Verificar agora",
  sync_now: "Sincronizar agora",
  clear_logs: "Registos vazios",
  saveAndGoBack: "Guardar e regressar",
  full_day: "Dia inteiro",
  activate_scanner: "O scanner está ativado",
  scanner_is_inactive: "Scanner inativo",
  change_project_by_scan_qr: "Digitalize o código QR do projeto para o qual pretende mudar.",
  scan_device_by_qr: "Digitalize o código QR do dispositivo que pretende utilizar.",
  no_access_to_camera_please_connect_device_manually: "Infelizmente, não foi possível aceder à câmara. Por favor, introduza o código do dispositivo manualmente.",
  no_access_to_camera_please_clockin_manually: "Infelizmente, não foi possível aceder à câmara, por favor carimbe manualmente.",
  qr_code_login: "Registo do código QR",
  scan_to_login: "Digitalize o seu código QR para iniciar sessão.",
  checklist_was_saved: "A lista de controlo foi guardada",
  question_save_changes_short: "Guardar alterações?",
  question_save_changes: "Pretende guardar as alterações?",
  question_delete_checklist_short: "Eliminar a lista de controlo?",
  question_delete_checklist: "Tem a certeza de que pretende eliminar a lista de verificação?",
  checklist_is_sending: "Lista de verificação será enviada",
  checklist_sent_successfully: "Lista de verificação enviada com êxito 🎉",
  checklist_could_not_be_sent: "Não foi possível enviar a lista de verificação, tente novamente mais tarde.",
  checklist_transmission_problems_in_the_past: "No passado, houve problemas de transferência com alguns arquivos.",
  checklist_send_with_potential_data_loss: "Gostaria de tentar enviar a lista de verificação sem estes ficheiros?",
  documentation_is_sending: "A documentação do projeto será enviada...",
  documentation_sent_successfully: "Documentação do projeto enviada com sucesso 🎉",
  confirm_documentation_dismissal: "Quer mesmo deitar fora a documentação?",
  discard_unsaved_changes: "Queres descartar as tuas alterações?",
  documentation_will_be_sent_when_online: "A documentação será enviada assim que estiver novamente em linha.",
  confirmation_is_sending: "A confirmação do projeto é enviada",
  ask_for_geo_permission: "Esta aplicação precisa da sua localização, " + "mas não há autorização para o fazer.\n\n" + "Gostaria de abrir as definições?",
  all_projects: "Todos os projectos",
  half_day: "Meio dia",
  start_end: "Por tempo",
  my_area: "A minha área",
  my_area_video_teaser_clockin_explained_by_frederik: "clockin explicado por Freddi",
  add_time: "Criar tempo",
  show_times_in_confirmation: "Horários dos espectáculos em confirmação",
  change_time: "Tempo de modificação",
  finish_project: "Finalizar o projeto",
  finish_project_date: "Finalizar a nomeação",
  unfinish_project: "Reabrir o projeto",
  unfinish_project_date: "Reabrir a marcação",
  absence_overview: "Gerir as ausências",
  edit_absence: "Editar ausência",
  edited_absence: "Ausência processada",
  created_absence: "Pedido de férias criado com êxito",
  creating_absence: "O seu pedido de férias será agora criado",
  error_creating_absence: "Erro ao criar o pedido de férias",
  create_absence: "Criar ausência",
  deleted_absence: "Retirada do pedido de ausência",
  new_request: "Nova aplicação",
  your_requests: "As suas aplicações",
  planned_days: "Dias programados",
  planned_hours: "Horário agendado",
  used_days: "Dias utilizados",
  used_hours: "Horas gastas",
  free_days: "Dias de folga",
  free_hours: "Horas de férias",
  open_days: "Dias abertos",
  open_hours: "Horário de funcionamento",
  withdraw_request: "Retirada do pedido",
  change_request: "Pedido de alteração",
  request_was_approved: "A sua candidatura foi aprovada",
  request_is_pending: "A sua candidatura ainda não foi aprovada",
  request_was_rejected: "A sua candidatura foi rejeitada",
  add_attachment: "Adicionar anexo",
  message_optional: "Mensagem (facultativo)",
  filed_on: "Enviado em",
  this_year: "Este ano",
  search_sub_projects: "Em que subprojecto gostaria de trabalhar?",
  error_occurred: "Ocorreu um erro, tente novamente mais tarde.",
  re_record: "Apagar e voltar a gravar este vídeo?",
  delete_video: "Apagar gravações?",
  no_results_found: "Não foram encontrados resultados",
  record_again: "Retentar",
  request_valid_email: "Introduza um endereço de correio eletrónico válido.",
  request_valid_company_name: "Introduza um nome de empresa válido.",
  request_valid_first_name: "Introduza um nome próprio válido.",
  request_valid_last_name: "Introduza um apelido válido.",
  total_duration_today: "Tempo total hoje",
  show_daily_protocol: "Mostrar registo diário",
  change_profile_pic: "Alterar a imagem do perfil",
  logout_account: "Desligar a conta",
  you_are_working: "Está a trabalhar agora mesmo!",
  you_are_taking_a_break: "Está a fazer uma pausa!",
  activity_edited: "Atividade processada",
  activity_edited_undo: "Edição anulada com sucesso",
  activity_edited_missing_project: "Oh, o projeto ainda está em falta!",
  activity_deleted: "Atividade eliminada",
  activity_deleted_undo: "Restauração da atividade eliminada",
  activity_created: "Nova atividade criada",
  activity_created_undo: "Atividade recém-criada retirada",
  correct_working_hours: "Horários de trabalho corretos",
  your_changes_are_being_saved: "As suas alterações serão agora guardadas.",
  manage_working_hours: "Gerir o horário de trabalho",
  delete_activity: "Eliminar atividade",
  start_navigation: "Iniciar a navegação",
  no_valid_email: "O endereço de correio eletrónico introduzido não é válido.",
  delete_checklist: "Eliminar a lista de controlo",
  active_checklists: "Listas de verificação activas",
  scan_qr_code: "Ler o código QR",
  switch_to_office_center: "Mudar para o centro de escritórios",
  confirm_project_completion_short: "Finalizar o projeto",
  confirm_project_date_completion_short: "Finalizar a nomeação",
  project_completed: "Projeto concluído!",
  project_date_completed: "Nomeação concluída!",
  confirm_project_uncompletion_short: "Reabrir o projeto",
  confirm_project_date_uncompletion_short: "Reabrir a marcação",
  project_uncompleted: "Projeto ativado",
  project_date_uncompleted: "Data de ativação",
  choose_project: "Selecionar projeto",
  choose_sub_project: "Selecionar subprojecto",
  choose_site: "Selecionar local",
  active_projects: "Projectos activos",
  completed_term: "finalizado",
  completed_projects: "Projectos concluídos",
  end_of_work: "Tenha uma boa noite",
  correct_time: "Hora correta",
  you_stamp_x: "Carimbar",
  enter_pin: "Introduzir PIN",
  wrong_pin: "Introdução incorrecta do PIN",
  pin_change_required: "Foi-lhe pedido que alterasse o seu PIN",
  enter_new_pin: "Introduzir novo PIN",
  approve_pin: "Confirmar PIN",
  no_projects_scheduled: "Para a {day} nenhum projeto é armazenado.",
  you_clock_in_project: "Regista-se agora o tempo de trabalho do projeto.",
  project_scan_error: "Este código não é válido para nenhum projeto.",
  show_more_days: "mostrar mais dias",
  show_more_times: "Mostrar mais vezes",
  only_show_today: "mostrar apenas hoje",
  todays_total_time: "Tempo total hoje",
  everything_synced: "Os seus dados estão actualizados!",
  upload_in_progress: "Os dados são carregados...",
  who_are_you: "Quem és?",
  is_uploading_to_server: "As suas alterações estão atualmente a ser transferidas para o centro de escritórios.",
  offline_and_data_is_stored_locally: "As suas alterações serão em breve transferidas para o centro de escritórios. ",
  show_more: "Mostrar mais",
  activity_edited_wrong_date: "Introduziu a data errada.",
  confirm_logout: "Quer mesmo cancelar a subscrição?",
  confirm_clockout: "Tens a certeza de que queres sair por hoje?",
  gps_is_active: "Os dados GPS são transmitidos",
  location_tracking_is_active: "Para ativar a localização por GPS.",
  app_settings: "Definições da aplicação",
  clock_reminder: "Carimbo - Lembrete",
  mon_to_fri: "Padrão: segundas a sextas-feiras",
  logout: "Desligar a conta",
  refresh: "Atualizar",
  prompt_language_settings: "Defina aqui o idioma da aplicação.",
  prompt_clock_reminder: "Lembrete através de notificação push para corresponder ao seu trabalho diário.",
  register_company: "Registar a empresa",
  use_code: "Utilizar código",
  our_customers: "Os nossos clientes",
  free_test_now: "Teste agora gratuito",
  tier_attendance: "Apenas registo as horas de trabalho e as pausas.",
  tier_documentation: "Também gostaria de reservar horas de trabalho em projectos que eu gero no clockin.",
  your_tier: "A sua encomenda",
  all_clockin_functions: "Todas as funções de entrada de relógio",
  checklists_formulars: "Listas de controlo e funções",
  projectfile_incl_chat: "Ficheiros digitais do projeto (incluindo chat)",
  photo_sketch_note: "Função de fotografia, esboço e notas",
  digital_signature: "Assinaturas digitais",
  datev_connection: "Ligação DATEV",
  calendar_absences: "Gerir o calendário e as ausências",
  individual_design: "Visual personalizado",
  attendance_time_tracking: "Registo do tempo de paragem através do terminal tablet",
  mobile_time_tracking: "Registo de tempo móvel através da aplicação para smartphone",
  browser_time_tracking: "Registo do tempo de navegação no PC para escritório em casa",
  help_use_code: "Introduza o código que pode encontrar no centro de escritório em dispositivos móveis/funcionários.",
  wrong_code: "Código errado",
  wrong_code_text: "O código não é válido. Por favor, tente novamente com um código válido",
  wrong_code_text_short: "O código é inválido",
  clockin_logo: "Logótipo Clockin",
  invalid_qr_code: "Código QR inválido",
  invalid_qr_code_text: "O código QR digitalizado não é válido. Por favor, digitalize um código de relógio válido.",
  code_already_connected: "Pode ligar o seu dispositivo com este código. Mas já está ligado.",
  wrong_credentials: "Dados de acesso incorrectos",
  wrong_credentials_text: "Não foi possível encontrar a combinação de e-mail e palavra-passe que introduziu. Verifique a sua introdução e tente novamente.",
  new_pin: "Introduzir novo PIN",
  choose_next_action: "Escolha a sua próxima ação",
  name_of_software_package: "Nome do pacote de software",
  select_teamleader: "Quem carimba a equipa?",
  select_teamleader_description: "Para continuar as actividades de carimbagem, selecione uma pessoa que irá assumir o controlo do dispositivo.",
  clocked_in_on_this_device: "Carimbado neste dispositivo",
  not_clocked_in_on_this_device: "Não carimbado neste dispositivo",
  select_new_teamleader: "Quem deve carimbar a equipa agora?",
  switch_teamleader: "Entrega do dispositivo",
  just_me: "Apenas me dê um tempo",
  select_the_new_teamleader: "Nomear o novo chefe de equipa",
  back_to_selection: "voltar à seleção",
  manage_team: "Gerir a equipa",
  total_time_team: "Tempo total da equipa",
  count_members_clocked_in: "{clockedin}/{members} Membros da equipa carimbados em",
  whole_team: "Toda a equipa",
  teammembers_still_clockedin: "Escolher se quer marcar o ponto apenas para si ou para todos os membros da equipa?",
  clockout_all: "Eliminar todos os",
  select_employee: "Primeiro, selecionar um utilizador",
  something_went_wrong: "Algo correu mal, tente novamente mais tarde.",
  new_pin_successfully_changed: "PIN alterado com sucesso",
  enter_pin_before_clockin_prompt: "Primeiro, introduza o seu PIN individualmente para iniciar a sessão.",
  enter_pin_before_clockout_prompt: "Primeiro, introduza o seu PIN individualmente para carimbar.",
  delete_activity_alert_title: "Eliminar atividade",
  delete_activity_alert_msg: "Tem a certeza de que pretende eliminar a atividade?",
  delete_absence_message: "Tem a certeza de que pretende retirar a candidatura?",
  delete_absence_title: "Retirada do pedido",
  are_you_sure: "Tens a certeza?",
  request_password: "Pedir nova palavra-passe",
  password_requested: "Foi enviada para o seu endereço de correio eletrónico uma ligação para uma nova palavra-passe",
  no_email_retrieved: "Não recebeu correio eletrónico? Verifique a sua pasta de spam ou tente novamente.",
  name_of_customer: "Nome do cliente",
  missing_permissions_homepage_text: "Não tem autorização para alterar a sua atividade neste dispositivo. Contacte o seu administrador para obter acesso.",
  no_permission_warning_my_area: "Não tem autorização para aceder a esta área. Contacte o seu administrador para obter acesso.",
  employee_clocked_in: "{name} registado!",
  employee_clocked_out: "{name} cancelado!",
  no_employee_to_qr_code_warning: "Não foi possível encontrar nenhum empregado para este código QR.",
  no_employees_registered_heading: "Ainda não foi atribuído nenhum empregado a este dispositivo.",
  no_employees_registered_body: "No centro de escritório, nas definições do dispositivo móvel, pode atribuir colaboradores que podem registar os seus tempos neste dispositivo.",
  no_employee_found: "Infelizmente, não foi possível encontrar ninguém com este nome.",
  no_employee_assigned: "Nenhum funcionário atribuído",
  you_need_help: "Precisa de ajuda?",
  here_you_can_get_help_to_register_employees_for_device: "Aqui encontra todas as informações sobre como atribuir colaboradores a um dispositivo.",
  show_time: "Criar tempo",
  export_timesheet: "Exportar folha de horas",
  select_month: "Selecionar mês",
  internet_connection_required: "Para tal, é necessária uma ligação à Internet.",
  select_an_activity_to_clockin_your_team: "Selecione uma atividade para carimbar na sua equipa.",
  confirm_uploading_sqlite_for_debugging: "Tem a certeza de que pretende carregar os dados na aplicação para suporte do Clockin?",
  no_tasks_available: "Sem tarefas disponíveis",
  click_to_add_tasks: "Clique para adicionar tarefas",
  scan_nfc_tag: "Por favor, segure o seu cartão para o leitor.",
  link_nfc_tag: "Vincular tag NFC",
  select_employee_for_nfc_tag: "Selecione um funcionário para vincular esta tag NFC:",
  nfc_tag_linked_successfully: "Tag NFC com sucesso com {name} ligado.",
  nfc_linking_failed: "Não foi possível associar a etiqueta NFC. Por favor, tente novamente.",
  nfc_not_enabled: "NFC não é suportado por este dispositivo ou está desativado.",
  nfc_initialization_failed: "Infelizmente, algo correu mal. Por favor, tente novamente.",
  nfc_scan_failed: "Infelizmente, algo correu mal. Por favor, tente novamente.",
  nfc_no_tag_found: "Nenhuma tag NFC foi encontrada.",
  nfc_tag_already_linked_to: "Esta etiqueta NFC já está disponível com {name} ligado.",
  nfc_scan_active: "Verificação NFC ativa",
  nfc_linking_enabled: "As tags NFC agora podem ser vinculadas. Por favor, segure a tag NFC para ser vinculado ao leitor NFC agora.",
  nfc_all_employees_linked: "Todos os funcionários atribuídos a este dispositivo já foram vinculados.",
  no_employee_to_nfc_warning: "Nenhum funcionário foi encontrado para esta tag NFC.",
  select_employee_to_link_nfc: "A quem a tag NFC deve ser vinculada?",
  new_onboarding: {
    personal_app_manager: {
      heading: {
        welcome: "Bem-vindo ao Clockin",
        clocking_time: "Tempos em pista",
        push_notifications: "Não te esqueças de nada"
      },
      text: {
        clocking_time: "O cronómetro é o teu ponto de partida para cada atividade. Tu tratas do teu trabalho, a aplicação trata da documentação.",
        push_notifications: "Agora ativa as notificações. O Clockin lembra-te se te esqueceres de um carimbo e certifica-te de que recebes tudo o que é importante imediatamente."
      },
      button: {
        lets_go: "Começar agora"
      }
    },
    my_area: {
      heading: {
        my_area: "A minha área",
        absences: "Ausências e candidaturas",
        settings: "Definições pessoais"
      },
      text: {
        my_area: "O local central onde pode controlar imediatamente as suas horas de trabalho e as horas extraordinárias. A partir daqui, pode gerir o seu horário de trabalho, consultar o seu registo diário, apresentar pedidos e visualizar os seus horários.",
        absences: "Gerir os pedidos de férias, dias de baixa e outras ausências. Mantenha-se sempre a par do estado dos seus pedidos e apresente novos pedidos de forma rápida e fácil com apenas alguns cliques.",
        settings: "Envie mensagens à empresa ou altere as suas definições pessoais e, se quiser alterar a sua palavra-passe, também o pode fazer aqui!"
      },
      button: {
        lets_go: "Comece"
      }
    }
  },
  onboarding: {
    personal_app: {
      heading: {
        your_time_matters: "Porque o seu tempo conta",
        clock_in: "Estampagem",
        switch_task: "Restamping",
        clock_out: "Carimbar",
        thats_it: "É isso mesmo!"
      },
      text: {
        your_time_matters: "Com o clockin, ajudamo-lo a concentrar-se no essencial. Registe facilmente o seu tempo de trabalho com apenas um clique.",
        clock_in: "Basta um clique e o seu relógio é imediatamente ativado. O Clockin guarda os seus dados automaticamente e pode estar sempre atento a tudo.",
        switch_task: "Tem outro projeto, está a fazer uma pausa ou está a viajar para o seu próximo compromisso? Basta mudar o seu carimbo para a sua nova atividade. O resto é registado automaticamente.",
        clock_out: "E, com um clique, é eliminado.",
        thats_it: "Já o fez e está pronto para registar o seu tempo de trabalho. Se precisar de ajuda, basta contactar-nos. Tudo é fácil com o clockin - incluindo a comunicação connosco."
      },
      button: {
        your_time_matters: "Mostre-me como se faz",
        thats_it: "Começar agora"
      }
    },
    team_app: {
      heading: {
        your_time_matters: "Porque o seu tempo conta",
        clock_in: "Estampagem",
        clock_in_team: "Relógio na equipa",
        switch_task: "Restamping",
        change_teamleader: "Entrega do dispositivo",
        clock_out: "Carimbar",
        thats_it: "É isso mesmo!"
      },
      text: {
        your_time_matters: "Com o clockin, ajudamo-lo a concentrar-se no essencial. Registe facilmente as horas de trabalho da sua equipa com apenas um clique.",
        clock_in: "Selecione uma pessoa que marque o ponto para a equipa e, com um clique, o seu ponto será marcado diretamente. O clockin guarda os seus dados automaticamente e pode acompanhar tudo em qualquer altura.",
        clock_in_team: "Basta carimbar diretamente a sua equipa. Quer sejam todos ao mesmo tempo ou apenas membros individuais.",
        switch_task: "Tem outro projeto, está a fazer uma pausa ou está a viajar para o seu próximo compromisso? Basta carimbar a sua nova atividade. O resto será registado automaticamente.",
        change_teamleader: "Está a terminar o trabalho, tem de sair ou já não está a marcar o ponto para a equipa? Basta entregar o dispositivo na aplicação e tudo volta ao normal.",
        clock_out: "E com um clique, o utilizador e a sua equipa são eliminados. É claro que também pode carimbar membros individuais em qualquer altura.",
        thats_it: "Já está pronto para registar o tempo de trabalho da sua equipa. Se precisar de ajuda, basta contactar-nos. Tudo é fácil com o clockin - incluindo a comunicação connosco."
      },
      button: {
        your_time_matters: "Mostre-me como se faz",
        thats_it: "Começar agora"
      }
    },
    my_area: {
      heading: {
        welcome: "Bem-vindo à sua região",
        my_area: "A minha área",
        create_time: "Criar tempo",
        change_time: "Hora correta",
        absences: "Ausências e candidaturas",
        settings: "Definições pessoais",
        thats_it: "É isso mesmo!"
      },
      text: {
        welcome: "Descubra ainda mais formas de gerir o seu tempo de trabalho de forma eficiente e fácil. Vamos dar uma vista de olhos à sua área.",
        my_area: "O local central onde pode controlar imediatamente as suas horas de trabalho e as horas extraordinárias. A partir daqui, pode gerir o seu horário de trabalho, consultar o seu registo diário, apresentar pedidos e visualizar os seus horários.",
        create_time: "Esqueceu-se de introduzir uma hora ou gostaria de acrescentar horas mais tarde? Não há problema! Adicione os tempos em falta, registe as pausas e mantenha a sua conta de tempo de trabalho actualizada.",
        change_time: "Quer corrigir os seus tempos? Não há problema! Com o clockin, pode corrigir e ajustar facilmente as horas incorrectas.",
        absences: "Gerir os pedidos de férias, dias de baixa e outras ausências. Mantenha-se sempre a par do estado dos seus pedidos e apresente novos pedidos de forma rápida e fácil com apenas alguns cliques.",
        settings: "Envie mensagens à empresa ou altere as suas definições pessoais e, se quiser alterar a sua palavra-passe, também o pode fazer aqui!",
        thats_it: "Conseguiu! Agora pode gerir o seu tempo sem esforço, organizar as suas ausências e concentrar-se no que é importante: o seu trabalho. Boa sorte com o seu tempo produtivo!"
      },
      button: {
        welcome: "Mostre-me como se faz",
        thats_it: "Começar agora"
      }
    },
    clock: {
      clockin_now: "Bloquear agora",
      clock_your_first_time_now: "& gravar a sua primeira vez"
    }
  },
  surveys: {
    nps: {
      thanks_for_using_clockin: "Obrigado por utilizar o clockin!",
      question: "Qual é a probabilidade de recomendar o clockin a amigos ou colegas?",
      very_likely: "Muito provável",
      very_unlikely: "Muito improvável",
      help_us_improve: "Como podemos melhorar o relógio para si?",
      what_do_you_agree_with: "Quais são as afirmações com que concorda?",
      choose_three_statements: "Escolha até três afirmações.",
      hard_to_use: "difícil de operar",
      lacking_features: "Demasiadas funções",
      does_not_help_me: "não facilita o meu dia de trabalho",
      confusing: "confuso",
      poorly_implemented: "Funções mal implementadas",
      too_buggy: "demasiado propenso a erros",
      too_slow: "tempos de carregamento longos",
      what_else: "Há mais alguma coisa que gostaria de nos dizer?",
      can_we_ask_you_a_few_questions: "Podemos fazer-lhe mais algumas perguntas?",
      how_happy_are_you_with_the_introduction_of_clockin: "Qual é o seu grau de satisfação com a introdução do \"clockin\" na sua empresa?",
      how_much_do_you_enjoy_using_clockin: "O que acha da utilização do clockin?",
      how_much_easier_does_clockin_make_your_work: "Em que medida é que o relógio facilita o seu trabalho diário?",
      how_happy_are_you_with_the_following_aspects: "Qual é o seu grau de satisfação relativamente aos seguintes pontos?",
      clarity_of_the_app: "Clareza da aplicação",
      simplicity_of_use: "Simplicidade de funcionamento",
      app_features: "Funções na aplicação",
      feedback_received: "Os seus comentários foram recebidos. Obrigado pelo seu tempo.",
      thanks_for_taking_the_time: "Obrigado pelo vosso tempo.",
      what_can_we_do_to_improve: "Pode contar-nos mais sobre a sua experiência para que possamos fazer ainda melhor da próxima vez?",
      what_can_we_do_to_get_it_right: "Pode contar-nos mais sobre a sua experiência para que, da próxima vez, possamos fazer tudo corretamente?",
      comment_placeholder: "A sua mensagem"
    }
  },
  travel_logs: {
    add: "Adicionar detalhes da viagem",
    edit: "Editar detalhes da viagem",
    saving: "Os detalhes da viagem são guardados...",
    saved_successfully: "Detalhes da viagem guardados com sucesso!",
    unable_to_save: "Infelizmente, isso não resultou 😢"
  },
  attach_file: "Anexar ficheiro",
  image_to_text: {
    info: "Certifique-se de que o texto é claramente reconhecível e pode ser visto na íntegra na imagem.",
    attach_image: "Anexar fotografia",
    processing: "O seu texto será lido em.",
    processing_failed: "Infelizmente, a importação não funcionou 😢",
    no_text_found: "Não foi possível reconhecer qualquer texto."
  },
  correction_enter_reason: "Indique o motivo da correção.",
  daily_notes: {
    add: "Escrever uma nota",
    edit: "Editar nota",
    saving: "A nota é guardada...",
    saved_successfully: "Nota guardada com sucesso!",
    unable_to_save: "Infelizmente, isso não resultou 😢",
    no_notes_yet: "Nenhuma nota criada",
    create_note: "Criar"
  },
  calendar_sync: {
    title: "Sincronizar o plano de implantação",
    description: "Sincronize o seu horário de trabalho com um calendário e mantenha-se atento a compromissos antigos e novos.",
    url: "Endereço em formato iCal",
    url_description: "Pode utilizar este endereço para aceder a este calendário a partir de outras aplicações.",
    note: "Dica",
    note_description: "Em alguns calendários, pode demorar até 24 horas para que os novos compromissos sejam apresentados.",
    sync_now: "Sincronizar o calendário",
    copied: "URL do calendário copiado."
  },
  registration: {
    skip_all: "Saltar tudo",
    already_signed_up: "Já tenho uma conta",
    title_1: "Vamos lá começar! Que horas gostaria de registar com o clockin?",
    description_1: "Deixe-nos personalizar o relógio para si",
    option_1_a: "Tempo de trabalho geral (entrada, saída e pausa)",
    option_1_b: "Horário de trabalho do projeto",
    title_2: "Gostaria de documentar?",
    description_2: "Que requisitos devem ser cumpridos para o efeito?",
    option_2_a: 'Fotos',
    option_2_b: "Esboços",
    option_2_c: "Função de nota",
    option_2_d: "Listas de controlo e formulários",
    option_2_e: "Ficheiros de projectos digitais",
    title_3: "Que mais gostaria de digitalizar?",
    description_3: "Há muito mais para descobrir no clockin, talvez haja algo para si.",
    option_3_a: "Férias",
    option_3_b: "Doenças e ausências",
    option_3_c: "Ficheiro pessoal digital",
    option_3_d: "Análise da empresa",
    option_3_e: "Planeamento operacional",
    option_3_f: "Consultor fiscal em matéria de transferência de dados (DATEV)",
    title_4: "Em que sector opera a sua empresa?",
    description_4: "Queremos conhecê-lo melhor para podermos adaptar melhor o relógio às suas necessidades.",
    option_4_a: "serviços",
    option_4_b: "Artesanato",
    option_4_c: "Saúde e bem-estar",
    option_4_d: "Compras, encomendas e comércio",
    option_4_e: "Hotelaria e restauração",
    option_4_f: "Automóveis, transportes e máquinas",
    option_4_g: "Outro sector",
    title_5: "Quantos trabalhadores fazem parte da sua empresa?",
    description_5: "Com o número de empregados, podemos personalizar o relógio de ponto de acordo com a dimensão da sua empresa.",
    title_6: "Ótimo! O seu relógio está agora configurado",
    description_6: "Tudo o que precisamos é do seu nome.",
    input_6_a: "Empresa",
    input_6_b: "Nome próprio",
    input_6_c: "Apelido",
    input_6_d: "Número de telefone",
    title_7: "Está pronto para começar! Experimente o clockin 14 dias de graça!",
    input_7_a: "O seu endereço eletrónico",
    description_7: "Para que endereço eletrónico devemos enviar a sua palavra-passe?",
    input_7_b: "Foi assim que tomei conhecimento",
    how_did_you_hear_about_clockin: "Como é que ouviu falar pela primeira vez do clockin?",
    recommendation_option_1: "Recomendação",
    recommendation_option_2: 'Facebook',
    recommendation_option_3: 'Instagram',
    recommendation_option_4: "Pesquisa na Internet",
    recommendation_option_5: 'LinkedIn',
    recommendation_option_6: "Plataforma de comparação",
    recommendation_option_7: "Artigos em revistas e em linha",
    known_from: "Conhecido por",
    agb_1: "Ao submeter o formulário, o utilizador aceita os ",
    agb_2: "GTC",
    agb_3: " e o ",
    agb_4: "Política de privacidade",
    start: "Iniciar o teste",
    validation_failed: "Por favor, preencha todos os campos corretamente."
  },
  clocki: {
    listening_heading: "Estou ouvindo você",
    listening_subtext: "como posso ajudá-lo?",
    hi_0: "Olá, em que posso ajudar?",
    hi_1: "Olá, em que posso ajudar?",
    hi_2: "Olá, em que posso ajudar?",
    hi_3: "Moin moin, o que posso fazer por si?",
    hi_4: "Olá, o que posso fazer por si?",
    hi_5: "Olá, em que posso ajudar?",
    // hi_1: 'Hi {name}​, sag mir, wie kann ich dir helfen?',
    // hi_2: 'Hi {name}​, wie kann ich dir helfen?',
    // hi_3: 'Hi {name}​, was kann ich für dich tun?',
    // hi_4: 'Moin {name}​, was kann ich für dich tun?',
    // hi_5: 'Hallo {name}​, wie kann ich dir helfen?',
    // hi_6: 'Grüß dich {name}​, wobei kann ich dich unterstützen?',
    // hi_7: 'Guten Tag {name}​, womit kann ich dir heute helfen?',
    speech_recognition_unavailable: "Infelizmente, o reconhecimento de voz não parece funcionar no seu dispositivo",
    microphone_permission_denied: "Infelizmente, não tenho acesso ao seu microfone. Por favor, verifique as autorizações nas definições para que o possa ouvir.",
    please_speak: "Já pode falar com o Clocki",
    create_activity: "Criar uma atividade",
    modify_activity: "Alterar atividade",
    delete_activity: "Excluir atividade",
    create_daily_note: "Criar uma nota diária",
    search_project: "Procurar um projeto",
    note_copied: "Nota copiada",
    create_absence_request: "Solicitar ausência",
    delete_absence: "Eliminar uma ausência",
    confirm_deletion: "Tem a certeza de que o seu {activity_label} Estampagem de {date} relógio deve ser excluído?",
    confirm_absence_deletion: "Tem a certeza de que o seu pedido de {category} da seringa {startDate} até {endDate} Quer excluir?",
    task_before_modification: "Antes: {task}",
    starts_at_before_modification: "Hora de início antes: {startsAt}",
    ends_at_before_modification: "Hora de término antes: {endsAt}",
    something_went_wrong: "Oh, algo correu mal, por favor tente novamente mais tarde.",
    was_this_helpful: "A Clocki poderia ajudá-lo?",
    actions: {
      CREATE_ABSENCE: {
        title: "Confirmar a ausência"
      },
      CREATE_DAILY_NOTE: {
        title: "Criar uma nota agora",
        daily_notes_disabled: "Infelizmente, a função de notas está desactivada. Por favor, peça ao seu administrador para ativar a função no centro de escritórios.",
        success: "Nota guardada com sucesso no registo diário 🎉"
      },
      CREATE_PROJECT_NOTE: {
        title: "Criar documentação agora",
        created_by_clocki: "Criado com o Clocki"
      },
      REDIRECT_TO_CORRECT_TIMES: {
        title: "Abrir \"Os meus tempos\" agora"
      },
      REDIRECT_TO_MY_AREA: {
        title: "Abrir \"A minha área\" agora"
      },
      REDIRECT_TO_CHANGE_PASSWORD: {
        title: "Abrir \"Change password\" agora"
      },
      CHANGE_ACTIVITY: {
        WORKING_TIME: "Carimbar o \"tempo de trabalho\" agora",
        PAUSE: "Carimbar \"Pausa\" agora",
        DRIVING_TIME: "Carimbar \"tempo de viagem\" agora",
        LOGOUT: "Desbloquear agora"
      }
    }
  },
  review_prompt: {
    do_you_like_clockin: "Você gosta de usar o Clockin?"
  },
  translation_failed: "Infelizmente, a tradução não funcionou 😕",
  video_transcript_not_available: "Não há transcrição disponível",
  video_upload_succeeded: "Upload do vídeo concluído.",
  video_upload_failed: "O upload do vídeo falhou.",
  video_send_failed: "O vídeo não pôde ser transmitido neste momento. Tentamos outra vez mais tarde.",
  uploading_video: "A carregar vídeo...",
  language_selection_header: "Selecionar idioma",
  language_selection_message: "Escolha a sua língua preferida",
  shifts: {
    my_shifts: "Os Meus Turnos",
    free_shifts: "Turnos livres",
    next_shift: "O teu próximo turno",
    shift_not_found: "Nenhuma camada encontrada",
    show_shift_plan: "Consulte este horário de turnos",
    no_shift_place: "Sem localização especificada",
    no_shifts_assigned: "Neste momento não estás atribuído a nenhum turno",
    free_shifts_unavailable: "Atualmente, não há turnos livres disponíveis",
    filter_shift_plans: "Horários de Turnos de Filtro",
    no_shift_plans_available: "Não há horários de turnos disponíveis",
    filter_locations: "Locais de filtro",
    no_locations_available: "Sem vagas disponíveis",
    no_plan_selected: "Sem horário de turno selecionado",
    no_shifts_for_plan: "Não foram encontradas camadas para este plano",
    no_shifts_for_location: "Não foram encontrados deslocamentos para o local selecionado",
    unknown_shift_plan: "Horário de turnos desconhecido",
    unknown_location: "Localização desconhecida",
    loading_more_shifts: "Carrega mais camadas..."
  },
  clockin_reminder_title: "Já estás a trabalhar? 🔔",
  clockin_reminder: "Lembra-te de registar o ponto.",
  clockout_reminder_title: "Já estás no fim do dia? 🔔",
  clockout_reminder: "Não se esqueça de bater o ponto.",
  choose_clockin_reminder_time: "Hora do lembrete de entrada",
  choose_clockout_reminder_time: "Hora do lembrete de saída do ponto",
  choose_break_reminder_time: "Duração da pausa",
  saved_successfully: "Salvo 👍 com sucesso",
  clock_reminder_channel_name: "Lembretes de Selos",
  clock_reminder_channel_description: "Lembretes para registar a entrada e saída",
  break_reminder_title: "Ainda estás a fazer uma pausa? ⏰",
  break_reminder: "Nota: O seu tempo de pausa ainda está a acabar.",
  // Video component translations
  video_not_supported: "O teu dispositivo não suporta o vídeo :/",
  video_loading_error: "Vídeo de carregamento por erro",
  video_retry: "Recarregar"
};